<template>
  <nav :class="'menu'">
    <TheMenuLevel :items="menu" />
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TheMenuLevel from './TheMenuLevel'

export default {
  name: 'TheMenu',
  components: {
    TheMenuLevel
  },
  computed: {
    ...mapGetters({
      menu: 'header/getMenu'
    })
  },
  methods: {
    ...mapActions({
      updateMenu: 'header/updateMenu'
    })
  }
}
</script>

<style lang="scss">
  .menu{
    @include media("small-medium"){
      padding-top: layout("spacing")/2;
      width: 100%;
      background-color: colors("background");
    }
  }
</style>
